<script lang="ts" setup>
import type { ProductDetailItem } from "~~/models/products";

defineProps<{ title?: string | undefined; description: string; product: ProductDetailItem }>();

const isVisible = ref(true);
</script>

<template>
  <UAlert
    v-show="isVisible"
    :close="{ variant: 'link', color: 'neutral', size: 'xs' }"
    :ui="{ root: 'ring-0 bg-[#FDECC0]', title: 'text-neutral' }"
    :title="title"
    @update:open="(val: boolean) => { isVisible = val; }"
  >
    <template #leading>
      <img src="/icons/info.svg" class="self-start shrink-0" alt="">
    </template>
    <template #description>
      <div class="gap-md flex flex-col">
        <div
          class="text-neutral [&_p]:leading-[22px] [&_ul]:list-inside [&_ul]:list-disc [&_ul]:mb-xs [&_ul_li]:leading-[24px] [&_a]:text-primary [&_a]:underline"
          v-html="description"
        />

        <div v-if="product">
          <NuxtLinkLocale :to="product.detailUrl">
            <div class="p-sm gap-sm lg:py-lg lg:px-md lg:gap-md flex flex-row rounded bg-white">
              <div class="size-[70px] shrink-0">
                <ProductImage
                  :image-url="product.mainImage?.relativeUrl"
                  :image-alt="product.name"
                  :show="{ iconLabel: false }"
                  class="mx-auto h-[65px] object-cover"
                />
              </div>

              <div class="flex flex-col grow my-auto">
                <span class="text-[13px] text-neutral-400">{{ product.number }}</span>

                <div class="flex flex-wrap items-center justify-between">
                  <p class="line-clamp-2 text-neutral text-[16px] font-semibold leading-6" :title="product.name">
                    {{ product.name }}
                  </p>

                  <div class="flex">
                    <ProductOrderBadge v-if="product.categoryInfo.isBackorderProduct" />
                  </div>
                </div>
              </div>
            </div>
          </NuxtLinkLocale>
        </div>
      </div>
    </template>
  </UAlert>
</template>

<style scoped>

</style>
